// ESM-Huelle fuer lib/scripts/components/CMP_CPushPanel.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CPushPanel(id) {
	this.construct(id);

	this.name = "CPushPanel";
	this.htmlType = "div";

	this.container = null;
	this.buttons = new Array();
	this.properties = {
		rows : 1,
		columns : 1,
		styles : {},
		defaultButton : {
			styles : {
				position : "absolute"
			}
		},
		disableType : "OVERLAY"
	}
	this.nextPanel = null;
	this.prevPanel = null;
}

CPushPanel.prototype = new CComponent;

CPushPanel.prototype.prepare = function () {
	/*var colSpace = parseInt(this.properties.styles.width.replace("%", "")) /
	this.properties.columns;

	var rowSpace = parseInt(this.properties.styles.height.replace("%", "")) /
	this.properties.rows;*/
	var colSpace = 100 / this.properties.columns;
	var rowSpace = 100 / this.properties.rows;
	var n = 0;
	var button;

	for (var r = 0; r < this.properties.rows; r++)
		for (var c = 0; c < this.properties.columns; c++) {
			if (this.buttons[n] && this.buttons.length>0  && this.buttons[n].addclass){
				var addclass=this.buttons[n].addclass;
			} else {
				addclass="";		
			}
			button = this.addChild(CPushButton, addclass);

			if (typeof this.buttons[n] != "undefined" && this.buttons[n].properties.styles) {
				if  (!this.buttons[n].properties.styles.width){
					this.buttons[n].properties.styles.width = colSpace * 0.90 + "%";
				}
				if  (!this.buttons[n].properties.styles.height){
					this.buttons[n].properties.styles.height = rowSpace * 0.85 + "%";
				}
				this.buttons[n].properties = combine(this.buttons[n].properties, this.properties.defaultButton);
				
				button.properties = combine(button.properties, this.buttons[n].properties);
			} else {
				button.properties = combine(button.properties, this.properties.defaultButton);
				button.properties.styles.visibility = "hidden";
			}

			button.properties.styles.top = rowSpace * r;
			button.properties.styles.top = button.properties.styles.top + "%";

			button.properties.styles.left = colSpace * c;
			button.properties.styles.left = button.properties.styles.left + "%";

			n++;
		}

	this.prepared = true;
}

export { CPushPanel };
